import { Radio as ORadio } from '@osui/ui';
export const RadioGroup = ORadio.Group;
RadioGroup.defaultProps = {
  optionType: 'button'
};
//# sourceMappingURL=es/components/RadioGroup/RadioGroup.js.map